async function deriveKey(keyStr, saltStr) {
    const baseKey = await window.crypto.subtle.importKey(
        "raw", new TextEncoder().encode(keyStr), "PBKDF2", false, ["deriveKey"]
    );
    const derivedKey = await window.crypto.subtle.deriveKey(
        {name: "PBKDF2", salt: new TextEncoder().encode(saltStr), iterations: 250000, hash: "SHA-256"},
        baseKey, {name: "AES-GCM", length: 256}, false, ["encrypt", "decrypt"]
    );
    return derivedKey;
}

function arrayBufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = "";
    for (let i = 0; i < bytes.byteLength; i += 1) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};

function base64ToUint8Array(base64) {
    try {
      const binaryString = atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i += 1) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes;
    } catch (error) {
      throw new Error("Invalid encrypted value. Unable to decode.");
    }
}

export async function encrypt(keyStr, text) {
    const salt = window.crypto.getRandomValues(new Uint8Array(16));
    const key = await deriveKey(keyStr, salt);
    const iv = window.crypto.getRandomValues(new Uint8Array(12));
    const encrypted = await window.crypto.subtle.encrypt(
        {name: "AES-GCM", iv: iv}, key, new TextEncoder().encode(text)
    );

    const encryptedArray = new Uint8Array(encrypted);
    const resultBytes = new Uint8Array(salt.length + iv.length + encryptedArray.length);
    resultBytes.set(salt, 0);
    resultBytes.set(iv, salt.length);
    resultBytes.set(encryptedArray, salt.length + iv.length);

    return arrayBufferToBase64(resultBytes);
}


export async function decrypt(keyStr, text) {
    const encryptedArray = base64ToUint8Array(text.trim());

    if (encryptedArray.length < 28) {
        throw new Error("Encrypted value is not valid. Please verify the column contents.");
    }

    const salt = encryptedArray.slice(0, 16);
    const iv = encryptedArray.slice(16, 28);
    const encrypted = encryptedArray.slice(28);
    const key = await deriveKey(keyStr, salt);

    try {
        const decrypted = await window.crypto.subtle.decrypt(
            {name: "AES-GCM", iv: iv}, key, encrypted
        );
        const decryptedText = new TextDecoder().decode(decrypted);
        return decryptedText;
    } catch (err) {
        console.error(err);
        throw new Error("Error: Invalid decryption key or tampered data.");
    }
}
